import $ from "jquery";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";
import { RubriqueDto } from "../../dto/GenApi.iNotPaie.Dto/RubriqueDto";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants from "../Controls/EventConstants";
import { FeatureFlagManagerInstance } from "../Controls/FeatureFlagManager";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import ModalAjoutRubrique from "./modalAjoutRubrique/modalAjoutRubrique";

@Component({
    components: {
        ModalAjoutRubrique: require("./modalAjoutRubrique/modalAjoutRubrique.vue.html")
    },
    beforeRouteEnter(to, from, next) {
        next(v => {
            const vm = (v as ListeRubriquesComponent);
            vm.getRubriques();
        });
    }
})
export default class ListeRubriquesComponent extends Vue {
    public rubriques: RubriqueDto[] = [];
    public rubriquesFiltred: RubriqueDto[] = [];
	public modalRubriqueIsVisible = false;
	public modalRubriqueIdUpdate = 0;

    public currentOrderColumn = "LibelleRubrique";
    public orderingDesc = true;

    public filterTypeRubrique = "T";
    public filterName = "";

    public dataReady = false;
    public displayArchivees = false;
    public test = "\\";
    public modalAjoutRubrique?: ModalAjoutRubrique = undefined;

    public canDoTransfert = false;

    public getRubriques(): void {
        if (ParametresInstance.societeCourante == undefined) {
            return;
        }

        ServicesFactoryInstance.RubriquesService.getRubriques(data => {
            this.rubriques = data;
            this.rubriquesFiltred = this.rubriques;
            this.getClassOfOrder(this.currentOrderColumn, true);
            this.doFilter();

            this.canDoTransfert = ParametresInstance.userIsCombinedAuthorized(["Administrateur", "AdministrateurPST"])
                && FeatureFlagManagerInstance.hasFeatureFlag(FeatureFlagModuleEnum.TransfertSql);

            this.dataReady = true;
        });
    }

    public getClassOfOrder(columnName: string, desc: boolean): string {
        if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
            return "active";
        }

        return "icons";
    }

    public orderBy(columnName: string): void {
        if (this.currentOrderColumn == columnName) {
            this.orderingDesc = !this.orderingDesc;
        } else {
            this.orderingDesc = true;
        }

        this.currentOrderColumn = columnName;
        this.doOrder();
    }

    public doOrder(): void {
        const orderingDesc = this.orderingDesc;
        const columnName = this.currentOrderColumn;
        if (this.rubriquesFiltred != undefined) {
            this.rubriquesFiltred = this.rubriquesFiltred.sort(function (a, b) {

                // Gestion des valeurs null
                if (a[columnName] === null) {
                    return 1;
                }

                if (b[columnName] === null) {
                    return -1;
                }

                if (a[columnName] < b[columnName]) {
                    return (orderingDesc ? -1 : 1);
                }
                if (a[columnName] > b[columnName]) {
                    return (orderingDesc ? 1 : -1);
                }

                return 0;
            });
        }
    }

    public doFilter(): void {
        // Filtre sur la nature de la rubrique et sur recherche (dans le code, le libellé et la nature).
        this.rubriquesFiltred = this.rubriques.filter(s => (this.filterTypeRubrique === "T" || s.CodeNature == this.filterTypeRubrique) &&
            ((s.LibelleRubrique ?? "").toUpperCase().includes((this.filterName ?? "").toUpperCase()) ||
                (s.NumeroSequence?.toString() ?? "").toUpperCase().includes((this.filterName ?? "").toUpperCase()) ||
                (s.CodeRubrique ?? "").toUpperCase().includes((this.filterName ?? "").toUpperCase())) &&
            s.EstArchivee == this.displayArchivees);

        this.doOrder();
    }

    public showModalRubrique(id?: number): void {
		this.modalRubriqueIdUpdate = id == null ? 0 : id;
		this.modalRubriqueIsVisible = true;
	}

    public archiverRubrique(id: number): void {
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Souhaitez-vous vraiment archiver cette rubrique ?",
            callBackYes: () => {
                ServicesFactoryInstance.RubriqueService.archiverRubrique(id, () => {
                    NotificationServiceInstance.SendSuccess("Rubrique archivée avec succès.");
                    this.getRubriques();
                });
            }
        });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    public openModaleTransfert(rubrique: RubriqueDto): void {
        const modalTransfert: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Cette action va envoyer votre élément vers la liste d'attente des transferts SQL. Souhaitez-vous continuer ?",
            showDialog: true,
            title: "Confirmation",
            callBackYes: () => {
                this.transfertRubrique(rubrique);
            }
        });

        EventBus.$emit(EventConstants.MODAL_ALERT, modalTransfert);
    }

    public transfertRubrique(rubrique: RubriqueDto): void {
        if (this.canDoTransfert && rubrique !== undefined) {
            ServicesFactoryInstance.EntiteEnAttenteService.addRubriqueToList(rubrique.Id, () => {
                NotificationServiceInstance.SendSuccess("L'élément <strong>" + rubrique.LibelleRubrique + "</strong> a bien été ajouté à la liste d'attente des transferts SQL.");
                this.dataReady = false;
                this.getRubriques();
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/rubriques/listeRubriques.ts